import { useState } from "react";
import { postCloneMassiveNotesURL } from "../../utils/ConstantsURL";
export const useMassiveClone = () => {
  const [loadingMassive, setLoadingMassive] = useState(false);

  const executeMassiveClone = async (token, params) => {
    setLoadingMassive(true);
    

    const endpoint = postCloneMassiveNotesURL();
    
    const body = {
      originDocumentId: parseInt(params.originDocumentId),
      originSectionId: parseInt(params.originSectionId),
      targetDocumentId: parseInt(params.targetDocumentId),
      targetSectionId: parseInt(params.targetSectionId),
      date: params.date
    };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || data.message || "Error en clonación masiva");

      return { success: true, data, message: data.message };
    } catch (error) {
      console.error("Error en executeMassiveClone:", error);
      return { success: false, error: error.message };
    } finally {
      setLoadingMassive(false);
    }
  };

  return { executeMassiveClone, loadingMassive };
};